<template>
    <div class="content">
        <el-table
            :data="projectList"
            border
            size="mini"
            height="100vw"
            tooltip-effect="dark"
            empty-text="暂无任务数据"
            style="width: 100%;">
            <el-table-column
                label="序号"
                fixed="left"
                type="index"
                align="center"
                width="50">
            </el-table-column>
            <el-table-column
                label="开始时间"
                show-overflow-tooltip
                prop="gatherPortStartTime"
                align="center"
                width="130">
            </el-table-column>
            <el-table-column
                label="截止时间"
                show-overflow-tooltip
                prop="gatherPortEndTime"
                align="center"
                width="130">
            </el-table-column>
            <el-table-column
                label="小柜"
                show-overflow-tooltip
                prop="box20Num"
                align="center"
                width="60">
            </el-table-column>
            <el-table-column
                label="大柜"
                show-overflow-tooltip
                prop="box40Num"
                align="center"
                width="60">
            </el-table-column>
            <el-table-column
                label="船名航次"
                show-overflow-tooltip
                prop="vesselAndVoyage"
                align="center"
                width="130">
            </el-table-column>
            <el-table-column
                label="站点"
                show-overflow-tooltip
                prop="stationName"
                align="center"
                width="100">
            </el-table-column>
            <el-table-column
                label="码头"
                show-overflow-tooltip
                prop="shipSide"
                align="center"
                width="90">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { getProjectList } from '@/api/api'

export default {
    name: 'project',
    data () {
        return {
            projectList: []
        }
    },
    created () {
        let params = {
            section: this.$route.query.section
        }
        getProjectList(params).then(res => {
            let result = res.data.result
            if (res.data.success && result) {
                this.projectList = result
            }
        })
    },
    methods: {

    }
}
</script>

<style scoped>
    .content{
        max-width: 640px;
    }
    /deep/ .el-table th{
        background-color: #f5f7fa!important;
    }
</style>



// WEBPACK FOOTER //
// src/views/project/index.vue